import { gql } from '@/__generated__';

/**
 * Abrir un ticket DGA. Antes esto viajaba en `updateDgaTicket` con `status: "open"` (AMARU-736).
 *
 * La selección trae `description` para que la caché de Apollo quede con el ticket completo: es el
 * mismo objeto que después prellena el formulario de corrección.
 */
const OPEN_DGA_TICKET = gql(`#graphql
  mutation OpenDgaTicket($deviceId: ID!, $input: OpenDgaTicketInput!) {
    openDgaTicket(deviceId: $deviceId, input: $input) {
      id
      dga {
        id
        ticket {
          id
          timestamp
          description
        }
      }
    }
  }
`);

export default OPEN_DGA_TICKET;
